import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { letterProofingApi } from "apis/eduidLetterProofing";
import { Splash } from "components/Common/Splash";
import { useAppSelector } from "eduid-hooks";
import { useEffect, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { AccountId } from "./AccountId";
import { Recommendations } from "./Recommendations";
/**
 * Renders the start page
 */
export function Start() {
    const chosen_given_name = useAppSelector((state) => { var _a; return (_a = state.personal_data.response) === null || _a === void 0 ? void 0 : _a.chosen_given_name; });
    const given_name = useAppSelector((state) => { var _a; return (_a = state.personal_data.response) === null || _a === void 0 ? void 0 : _a.given_name; });
    const surname = useAppSelector((state) => { var _a; return (_a = state.personal_data.response) === null || _a === void 0 ? void 0 : _a.surname; });
    const emails = useAppSelector((state) => state.emails.emails);
    const isLoaded = useAppSelector((state) => state.config.is_app_loaded);
    const [letterProofingState] = letterProofingApi.useLazyLetterProofingStateQuery();
    const username = useMemo(() => {
        var _a, _b;
        if (chosen_given_name) {
            return `${chosen_given_name} ${surname}`;
        }
        if (given_name) {
            return `${given_name} ${surname}`;
        }
        if (emails.length > 0) {
            return (_b = (_a = emails.find((mail) => mail.primary)) === null || _a === void 0 ? void 0 : _a.email) !== null && _b !== void 0 ? _b : "";
        }
        return "";
    }, [chosen_given_name, given_name, surname, emails]);
    useEffect(() => {
        if (isLoaded) {
            letterProofingState();
        }
    }, [isLoaded, letterProofingState]);
    return (_jsxs(Splash, { showChildren: isLoaded, children: [_jsxs("section", { className: "intro", children: [_jsx("h1", { children: _jsx(FormattedMessage, { id: "multiFactorAuth.title", defaultMessage: "Welcome, {username}!", description: "start main title", values: {
                                username: _jsx("strong", { children: username }),
                            } }) }), _jsx("div", { className: "lead", children: _jsx(AccountId, {}) })] }), _jsx(Recommendations, {})] }));
}
